import { useMutation, useQueryClient } from "react-query";
import type { UseMutationResult } from "react-query";
import type { UpdatePartnerRequest } from "common/models/api/models/UpdatePartnerRequest";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { partnersApi } from "../api/partnersApi";

export interface UseUpdatePartnerParams extends UpdatePartnerRequest {
    address: string;
}

export default function useUpdatePartner({
    onSuccess,
    ...options
}: UseCustomMutationOptions<unknown, unknown, UseUpdatePartnerParams> = {}): UseMutationResult<unknown, unknown, UseUpdatePartnerParams> {
    const queryClient = useQueryClient();
    return useMutation(
        async ({ address, ...request }: UseUpdatePartnerParams) => {
            const res = await partnersApi.updatePartner(address, request);
            return res.data;
        },
        {
            ...options,
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries([Queries.PARTNER, variables.address]);
                queryClient.invalidateQueries(Queries.PARTNER_FIND_ALL);
                onSuccess?.(data, variables, context);
            },
        },
    );
}
